// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__1vTx-","displayImage":"styles_displayImage__ATSFH","smallCoin":"styles_smallCoin__30adV","mdCoin":"styles_mdCoin__2BM19"};